import type {EditionApiModel} from '../../../../api/program/edition';
import type {Nullable} from '../../../utility-types';

import {isDefined} from '../../../typecheck';

export const isEditionIndividual = (
  edition?: Nullable<EditionApiModel>,
): boolean => isDefined(edition) && edition.group_size === 1;
